export const environment = {
  production: false,
  fdiHttpUrl: 'https://fdi.pxcl.io',
  fdiWsUrl: 'wss://fdi-ws.pxcl.io',
}
